module.exports = __webpack_public_path__ + "static/media/sarah.e0d41a2d.png";